import React from 'react'

import './navbar.css'
import SelectUnits from '../../containers/Select/SelectUnitsContainer'

import Logo from './../../static/images/ciaedu-logo.svg'
import { formatRoleName } from '../../utils/utils'

const NavBar = (props) => {
  const {
    container,
    isMenuOpen,
    buttonOpenDropDownRef,
    logout,
    role,
    toggleProfileDropdown,
    handleStopPropagation,
    user,
    hasProfileImage,
    handleClickOpenModal,
    unit
  } = props
  const containerClass = container ? 'container' : ''
  const visibleClass = isMenuOpen ? 'visible' : ''
  return (
    <div>
      <div className='nav' >
        <div className={`${containerClass}`}>
          <div className='nav-left'>
            <img className='nav__logo' src={Logo} alt='Companhia.Edu Logo' />
            <SelectUnits />
            {unit && role === 'fractal_operator' && (
              <div className='nav__middle'>
                <button onClick={handleClickOpenModal} className='button is-primary'>Visualizar Escola</button>
              </div>
            )}
          </div>
          <div className='nav-right'>
            <div className='user-menu'>
              <a className='user-menu__link'
                ref={buttonOpenDropDownRef}
                onClick={toggleProfileDropdown}>
                <span>{formatRoleName(role)}</span>
                <i className='fa fa-caret-down' aria-hidden='true' />
              </a>
              <div className={`dropdown-menu ${visibleClass}`} onClick={handleStopPropagation}>
                <div className='dropdown-menu__user-info'>
                  {hasProfileImage && (
                    <div className='dropdown-menu__user-info__avatar'>
                      <img src='http://via.placeholder.com/74x74' alt='imagem logo' />
                    </div>
                  )}
                  <div className='dropdown-menu__user-info__text-container'>
                    <div className='dropdown-menu__user-info__title'>{user.name}</div>
                    <div className='dropdown-menu__user-info__subtitle'>{user.email}</div>
                    <div className='dropdown-menu__user-info__role'>{formatRoleName(role)}</div>
                  </div>
                </div>
                <div className='dropdown-menu__user__divider' />
                <a className='dropdown-menu__user__link' onClick={logout}>
                  <i className='fa fa-sign-out' aria-hidden='true' alt='Sair do sistema' title='Sair dos sistema' />
                  Sair
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/NavBar/index.js